import React from 'react';
import { Box } from '@mui/material';

const Header = () => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', pt: 4, pl: 4 }}>
            <img src="/header-logo.png" alt="Logo" style={{ height: '94px' }} />
        </Box>
    );
};

export default Header;